import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import "./CollapsibleList.scss";

interface CollapsibleList {
  openCollapsible: boolean;
  title: string;
  onClick: () => void;
}

const CollapsibleList = (props: React.PropsWithChildren<CollapsibleList>) => {
  const { openCollapsible, title, onClick, children } = props;

  return (
    <List className="collapsible-list">
      <ListItem className="collapsible-list-header" onClick={onClick}>
        <ListItemText primary={title} />
        <IconButton>
          {openCollapsible ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </ListItem>
      <Collapse in={openCollapsible} timeout="auto">
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </List>
  );
};
export default CollapsibleList;
